export default __webpack_public_path__ + "static/media/Kiran.58c8fe7d.jpeg";